import { Tag } from 'antd'
import { COLORS } from 'app/constants'
import { useExchangeStore } from 'app/hooks/trade/exchangeStore'
import React from 'react'
import { Text } from 'styles/reactnative'
import { TagWrap } from '../AdminUserModal/UserInfoTabs/styles'
import { useExchangeList } from 'app/hooks/trade/exchangeList'

const Contracts2 = ({ data, created_at = undefined, showtrade=false }) => {
	const { data: EPs } = useExchangeList(true)
	const EP = EPs?.find(e => e.id === data?.exchange_pairs_id)

	return (
		<div
			style={{
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'space-between',
				width: '100%',
				minHeight: '32px',
				padding: '0 4px',
			}}>
			<div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
				<span
					style={{
						fontSize: '12px',
						fontWeight: '600',
						color: '#000',
						whiteSpace: 'nowrap',
					}}>
					{EP?.pairs || '-'}
				</span>
				<span
					style={{
						fontSize: '10px',
						color: '#f08800',
						fontWeight: '500',
						whiteSpace: 'nowrap',
					}}>
					({EP?.groupname || '-'})
				</span>
			</div>
			{showtrade && (
				<span
					style={{
						fontSize: '10px',
						color: data?.long_short == 'L' ? COLORS.darkRed : COLORS.darkBlue,
						fontWeight: '600',
						whiteSpace: 'nowrap',
					}}>
					{data?.long_short == 'L' ? '매수' : '매도'}
				</span>
			)}
		</div>
	)
}

export default Contracts2
